export enum DockAppointmentStatus {
  SCHEDULED = 'SCHEDULED',
  CHECKED_OUT = 'CHECKED_OUT',
  UNLOADED = 'UNLOADED',
  LOADED = 'LOADED',
  UNLOADING = 'UNLOADING',
  LOADING = 'LOADING',
  REQUESTED = 'REQUESTED',
  CHECKED_IN = 'CHECKED_IN',
  NO_SHOW = 'NO_SHOW',
  LATE = 'LATE',
  CANCELLED = 'CANCELLED',
  FACILITY_RESCHEDULED = 'FACILITY_RESCHEDULED',
  OPEN = 'OPEN',
}

export const SUCCESS_STATUSES = [DockAppointmentStatus.CHECKED_OUT];

export const INFO_STATUSES = [
  DockAppointmentStatus.SCHEDULED,
  DockAppointmentStatus.UNLOADED,
  DockAppointmentStatus.LOADED,
  DockAppointmentStatus.UNLOADING,
  DockAppointmentStatus.LOADING,
  DockAppointmentStatus.REQUESTED,
  DockAppointmentStatus.CHECKED_IN,
  DockAppointmentStatus.OPEN,
];

export const WARNING_STATUSES = [
  DockAppointmentStatus.LATE,
  DockAppointmentStatus.FACILITY_RESCHEDULED,
];

export const DANGER_STATUSES = [
  DockAppointmentStatus.NO_SHOW,
  DockAppointmentStatus.CANCELLED,
];
